import { useState } from "react";
import { useNavigate } from "react-router";
import classes from "../../Auth.module.css";
import { toast } from "react-toastify";
import AUTH_CONTEXT from "../../../../store";
import Button from "../../../../components/Button/Button";
import Card from "../../../../components/Card/Card";
import { BASE_PATH_TO_VIEW_IP_ADDRESS } from "../../../../base_routes_paths/auth_paths";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { BASE_PATH_TO_HOME } from "../../../../base_routes_paths/data_paths";
import { IPAddressServices } from "../../../../services/auth_services";

const AddIpAddress = () => {
    const { token } = AUTH_CONTEXT();
    const [isLoading, setIsLoading] = useState(false);
    const [IPAddress, setIPAddress] = useState("");
    const navigate = useNavigate();

    const submitHandler = (event) => {
        event.preventDefault();
        setIsLoading(true);
        const FetchApi = async () => {
            try {
                let response = await IPAddressServices.addIpAddress(token, navigate, IPAddress);

                setIsLoading(false);
                if (response.status === 207) {
                    return toast.error(response.error, {
                        position: "bottom-left",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        theme: "light",
                    })
                }
                navigate(BASE_PATH_TO_VIEW_IP_ADDRESS)
                toast.success("Data added successfully!!", {
                    position: "bottom-left",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            } catch (e) {
                setIsLoading(false);
                toast.error(e.message, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        };
        FetchApi();
    };

    return (
        <div className={classes.crumbs}>
            <Breadcrumbs aria-label="breadcrumb" >
                <Link underline="hover" color="inherit" href={BASE_PATH_TO_HOME}>
                    Dashboard
                </Link>
                <Typography color="text.primary">
                    Auth
                </Typography>
                <Typography color="text.primary">Add IP Address</Typography>
            </Breadcrumbs>
            <form onSubmit={submitHandler}>
                <Card className={classes.input}>
                    <div className={classes.Main_div}>Add Allowed IP Address</div>
                    <div className={classes.control} style={{ marginBottom: "1rem" }}>
                        <div className={classes.subfields}>
                            <label htmlFor="IpAddressList">IpAddress :</label>
                            <div>
                                <input
                                    value={IPAddress}
                                    type='text'
                                    onChange={(event) => {
                                        setIPAddress(event.target.value);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    {!isLoading && <Button type="submit">Add</Button>}
                    {isLoading && <p color="white">Sending request...</p>}
                </Card>
            </form>
        </div>
    )
}

export default AddIpAddress;
